module.exports = __webpack_public_path__ + "img/category-new-released-hover.0cdfcb9f.png";